// src/wallet/web3modal.ts
import { createAppKit } from '@reown/appkit/react';
import { EthersAdapter } from '@reown/appkit-adapter-ethers';
// DO NOT import networks from '@reown/appkit'
import { mainnet, sepolia, polygon, polygonAmoy } from '@reown/appkit/networks';
import { defineChain } from 'viem';

// Define the Hardhat network configuration using the library's own utility
export const hardhat = defineChain({
  id: 31337,
  name: 'Hardhat',
  nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://8555-firebase-kalakrutcreativekg1-1769075240619.cluster-ejd22kqny5htuv5dfowoyipt52.cloudworkstations.dev/'] },
  },
});

// 1. Get project ID from WalletConnect Cloud
const projectId = 'af6a6ff3baf7e99199d839ea4bce5c45';

// 2. Define app metadata
const metadata = {
  name: 'KalaKrut',
  description: 'A decentralized platform for artists and creators.',
  url: typeof window !== 'undefined' ? window.location.origin : 'https://kalakrutcreativekg1-3047-4bbf8.web.app/',
  icons: ['https://kalakrutcreativekg1-3047-4bbf8.web.app/logo.png']
};

// 3. Create the AppKit instance
export const web3Modal = createAppKit({
  adapters: [new EthersAdapter()],
  networks: [hardhat, polygonAmoy, polygon, sepolia, mainnet],
  metadata,
  projectId,
  allowUnsupportedChain: true,
  enableEIP6963: true,
  enableInjected: true,
  showWallets: true,
  featuredWalletIds: [
    'c57ca95b47569778a828d19178114f4db18a6353b59583d9a11c97ca945d', // MetaMask
    'fd20dc426c395345cf0e8344e5907794361e5a74c079b5c92f4e93'  // Coinbase
  ],
  features: {
    analytics: false,
    email: true,
    socials: ['google', 'x', 'apple'],
    onramp: false,
    swaps: false
  },
  themeMode: 'dark',
  themeVariables: {
    '--w3m-color-mix': '#0f172a',
    '--w3m-color-mix-strength': 20,
    '--w3m-accent': '#06b6d4',
    '--w3m-border-radius-master': '1rem'
  }
});
